import { useTranslation } from "react-i18next";
import { Badge, type IBadgeProps } from "@components/Badge/Badge";
import { CheckmarkIcon, CrossIcon } from "@components/icons";
import { Tooltip } from "@components/Tooltip/Tooltip";
import { PeriodState } from "@services/overview/types";
import { isNullOrUndefined } from "@utils/common";

interface IJointBillStatusBadgeProps {
  periodState: PeriodState;
  badgeSize?: IBadgeProps["size"];
  badgeVariant?: IBadgeProps["variant"];
}

const badgeProps: Record<PeriodState, IBadgeProps> = {
  [PeriodState.NoProviders]: {},
  [PeriodState.Waiting]: { color: "orange" },
  [PeriodState.Ready]: { color: "blue" },
  [PeriodState.Paid]: { color: "green", icon: CheckmarkIcon },
  [PeriodState.Unpaid]: { color: "red", icon: CrossIcon },
  [PeriodState.PartiallyPaid]: {
    color: "red",
    icon: CrossIcon,
  },
  [PeriodState.PartiallyPaidReady]: {
    color: "purple",
  },
};

export const JointBillStatusBadge: React.FC<IJointBillStatusBadgeProps> = ({
  periodState,
  badgeSize = "large",
  badgeVariant = "bubble",
}) => {
  const { t } = useTranslation();

  return (
    !isNullOrUndefined(periodState) && (
      <Tooltip content={t(`bill.periodState.${periodState}.description`)}>
        <Badge
          {...badgeProps[periodState]}
          size={badgeSize}
          variant={badgeVariant}
        >
          {t(`bill.periodState.${periodState}.title`)}
        </Badge>
      </Tooltip>
    )
  );
};
